import { createApp } from 'vue'

import App from './App.vue'
import antD from './vendor/ant-design'
import router from './router'
import store from './store'
import i18n from './locales'
import { useGTag } from './vendor/gtag'
import { useSentry } from './vendor/sentry'
import filters from './filters'

import 'driver.js/dist/driver.min.css'
import './assets/styles/global.less'

import IconFont from './components/IconFont'
import IconFont2 from './components/IconFont2'

;(async function () {
  let user
  try {
    user = await store.dispatch('login')
  } catch {
    return
  }

  store.dispatch('getAllUsers')

  const app = createApp(App)
    .use(antD)
    .use(router)
    .use(store)
    .use(i18n)
    .use(filters)

  useGTag(app, user.uid)
  useSentry(app, user)

  app.component('IconFont', IconFont)
  app.component('IconFont2', IconFont2)

  app.mount('#app')
})()
